import React from 'react';
import { TableRowReports } from './TableRow/TableRow';

const ReportsList = ({
  data,
  formatDate,
  getActionsByRoleAndStatus,
  activeTabIndex,
  setData,
}) => {
  const reportType = activeTabIndex === 0 ? 'nts' : 'ha';

  return (
    <TableRowReports
      activeTabIndex={activeTabIndex}
      data={data}
      setData={setData}
      formatDate={formatDate}
      getActionsByRoleAndStatus={getActionsByRoleAndStatus}
      reportType={reportType}
    />
  );
};

export default ReportsList;
